import DataUsageIcon from '@mui/icons-material/DataUsage';
import {Chip, Tooltip, lighten} from '@mui/material';
import {array, bool} from 'prop-types';
import React from 'react';
import {useGetProducts} from '@api/products';

const ReservationsChip = ({reservationsProductIds, showLabel = true}) => {
  const {data: products, isLoading} = useGetProducts();

  const tooltipText = reservationsProductIds
    .map(productAccessId => {
      const product = products?.find(p => p.id === Number(productAccessId));
      return product?.title;
    })
    .join(', ');

  if (isLoading || !products) {
    return false;
  }

  return (
    <Tooltip title={tooltipText}>
      <Chip
        color="primary"
        icon={<DataUsageIcon />}
        label={
          showLabel &&
          `${reservationsProductIds.length}/${products.length} products`
        }
        sx={theme => ({
          backgroundColor: 'primary.light',
          ...theme.applyStyles('light', {
            backgroundColor: lighten(theme.palette.primary.light, 0.6),
            color: 'primary.main',
          }),
        })}
      />
    </Tooltip>
  );
};

ReservationsChip.propTypes = {
  reservationsProductIds: array,
  showLabel: bool,
};

export default ReservationsChip;
